import { Pipe, PipeTransform } from "@angular/core";
import { parse,format,differenceInSeconds } from 'date-fns';

@Pipe({
    name:"filterCarStatusTimeLimit"
    ,pure: false
})
export class FilterCarStatusTimeLimit implements PipeTransform {
    transform(items : any[],limitMin:number = 10) {
        if(!items){
            return items;
        }

        return items.map((val,idx) => {
            // 지정 된 시간이 넘어가면 off 상태로 변환
            if(val.dtgRegDt){
                let regDtSrc = parse(val.dtgRegDt,"yyyy-MM-dd HH:mm:ss",new Date());
                let regDtNow = new Date();
                let diffSec = differenceInSeconds(regDtNow,regDtSrc);
                if(diffSec > limitMin * 60){
                    val.dtgKeyonYn = "0";
                    // val.dtgGpsStatus = "G";
                    // val.dtgGpsFaultYn = "0";
                    // val.dtgSpeedFaultYn = "0";
                    // val.dtgRpmFaultYn = "0";
                    // val.dtgBrakeFaultYn = "0";
                    // val.dtgInputFaultYn = "0";
                    // val.dtgOutputFaultYn = "0";
                    // val.dtgSaveFaultYn = "0";
                    // val.dtgCommFaultYn = "0";
                    // val.dtgDistFaultYn = "0";
                    // val.dtgPowerFaultYn = "0";
                }
            }
            return val;
        });
    }
}